module.exports = __webpack_public_path__ + "img/series-player.5d1827fe.svg";